<template>
  <b-card>
    <div class="widget-content">
      <div>
        <p class="label" style="text-align: left; color: #525456">Responses</p>
      </div>
      <div v-if="data.length > 0">
        <div class="legend" style="padding-top: 16px; padding-bottom: 16px">
          <ul>
            <li>Owner</li>
            <li>Contractor</li>
          </ul>
        </div>
        <div>
          <GChart
            id="question-chart"
            type="ColumnChart"
            :data="sortedData"
            :options="options"
            :events="events"
          />
          <svg
            style="width: 0; height: 0; position: absolute"
            aria-hidden="true"
            focusable="false"
          >
            <pattern
              id="pattern-fill"
              x="0"
              y="0"
              width="20"
              height="8"
              patternUnits="userSpaceOnUse"
            >
              <rect x="0" y="0" width="10" height="4" style="stroke: none; fill: #c4c4c4" />
            </pattern>
          </svg>
        </div>
      </div>
      <div v-else>No responses</div>
    </div>
  </b-card>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "ByQuestionGraph",
  props: {
    data: { type: Array, default: () => [] },
    currentInterval: { type: String, default: null },
    nextInterval: { type: String, default: null },
    prevInterval: { type: String, default: null },
  },
  components: {
    GChart,
  },
  data() {
    return {
      monthList: "1 Month",
      monthOptions: ["1 Month", "3 Month", "6 Month"],
      options: {
        bar: {
          groupWidth: "75%",
        },
        vAxis: {
          // title: "Vertical Axis",
          format: "0.0",
          minValue: 0.0,
          maxValue: 4.0,
          gridlines: { count: 5, color: "#c4c4c4" },
          minorGridlines: { count: 0 },
          textStyle: {
            color: "#525456",
            fontName: "Poppins",
            fontSize: 12,
          },
        },
        hAxis: {
          // title: "Horizontal Axis",
          textStyle: {
            fontName: "Poppins",
            fontSize: 10,
            color: "#525456",
          },
          minTextSpacing: 6,
          slantedText: true,
          slantedTextAngle: 43,
        },
        chartArea: {
          top: 10,
          bottom: 100,
          right: 15,
          left: 40,
        },
        tooltip: {
          isHtml: true,
          //ignoreBounds:true
        },
        //focusTarget: 'category',
        // width: 620,
        height: 340,
        animation: {
          duration: 500,
          easing: "out",
          startup: true,
        },
      },
      events: {
        ready: () => {
          var container = document.getElementById("question-chart");

          this.$helpers.handleAxisText(container);
          this.$helpers.handleGridlines(container);
        },
      },
    };
  },
  methods: {
    loadPrevInterval() {
      this.$emit("update", {
        period: this.prevInterval,
      });
    },
    loadNextInterval() {
      this.$emit("update", {
        period: this.nextInterval,
      });
    },
  },
  computed: {
    sortedData() {
      // console.log(this.data);
      if (this.data[0][3]) {
        if (this.data[0][3].label == "Owner") {
          let newData = [];
          let newCat = [
            "Category",
            {
              label: "Owner",
              type: "number",
            },
            {
              role: "style",
            },
            {
              label: "Contractor",
              type: "number",
            },
            {
              role: "style",
            },
          ];
          newData[0] = newCat;

          for (let i = 1; i < this.data.length; i++) {
            let oldCom = this.data[i],
              newCom = [oldCom[0]];

            newCom[1] = oldCom[3];
            newCom[2] = oldCom[4];
            newCom[3] = oldCom[1];
            newCom[4] = oldCom[2];

            newData[i] = newCom;
          }
          // console.log(newData);

          return newData;
        }
        return this.data;
      }
      return this.data;
    },
  },
};
</script>